
// state
export const state = {
  animation: true
}

// mutations
export const mutations = {
  disableAnimation (state) {
    state.animation = false
  }
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/buttonChangeSide.js